import React from 'react';
import { UserPlusIcon, UsersIcon, AlertTriangleIcon, ClockIcon, CheckCircleIcon, FileTextIcon, CreditCardIcon } from 'lucide-react';
export function VendorDashboard({
  vendors,
  setCurrentView,
  locale = 'en-US'
}) {
  // Calculate summary statistics
  const totalVendors = vendors.length;
  const activeVendors = vendors.filter(vendor => vendor.vendorStatus?.name === 'Active').length;
  const pendingOnboarding = vendors.filter(vendor => vendor.vendorStatus?.name === 'Pending Onboarding' || vendor.vendorStatus?.name === 'Invited').length;
  // Check for compliance issues
  const complianceIssues = vendors.filter(vendor => !vendor.isCompliant).length;
  // Get recent vendors (sorted by creation date)
  const recentVendors = [...vendors].sort((a, b) => new Date(b.createdUtc).getTime() - new Date(a.createdUtc).getTime()).slice(0, 5);
  // Get vendors with compliance issues
  const vendorsWithIssues = vendors.filter(vendor => !vendor.isCompliant || vendor.complianceIssues.length > 0).slice(0, 5);
  // Navigate to vendor list with status filter
  const handleViewVendorsByStatus = status => {
    // Store the filter preference (in a real app, this would be passed as a prop or through state management)
    sessionStorage.setItem('vendorStatusFilter', status);
    setCurrentView('vendors');
  };
  return <div data-id="element-20324">
      <div className="mb-8 flex justify-between items-center" data-id="element-20325">
        <div data-id="element-20326">
          <h3 className="text-xl font-semibold text-gray-900" data-id="element-20327">
            Vendor Dashboard
          </h3>
          <p className="mt-1 text-sm text-gray-500" data-id="element-20328">
            Overview of your vendor network and compliance status
          </p>
        </div>
        <div className="flex space-x-3" data-id="element-20329">
          <button onClick={() => setCurrentView('onboard-vendor')} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-20330">
            <UserPlusIcon className="h-4 w-4 mr-1" data-id="element-20331" />
            Add New Vendor
          </button>
          <button onClick={() => setCurrentView('vendors')} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-20332">
            <UsersIcon className="h-4 w-4 mr-1" data-id="element-20333" />
            View All Vendors
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 mb-8" data-id="element-20334">
        <button onClick={() => setCurrentView('vendors')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-20335">
          <div className="p-5" data-id="element-20336">
            <div className="flex items-center" data-id="element-20337">
              <div className="flex-shrink-0" data-id="element-20338">
                <UsersIcon className="h-6 w-6 text-gray-400" data-id="element-20339" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-20340">
                <dl data-id="element-20341">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-20342">
                    Total Vendors
                  </dt>
                  <dd data-id="element-20343">
                    <div className="text-lg font-medium text-gray-900" data-id="element-20344">
                      {totalVendors}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>

        <button onClick={() => handleViewVendorsByStatus('Active')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-20345">
          <div className="p-5" data-id="element-20346">
            <div className="flex items-center" data-id="element-20347">
              <div className="flex-shrink-0" data-id="element-20348">
                <CheckCircleIcon className="h-6 w-6 text-green-400" data-id="element-20349" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-20350">
                <dl data-id="element-20351">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-20352">
                    Active Vendors
                  </dt>
                  <dd data-id="element-20353">
                    <div className="text-lg font-medium text-gray-900" data-id="element-20354">
                      {activeVendors}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>

        <button onClick={() => handleViewVendorsByStatus('Pending Onboarding')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-20355">
          <div className="p-5" data-id="element-20356">
            <div className="flex items-center" data-id="element-20357">
              <div className="flex-shrink-0" data-id="element-20358">
                <ClockIcon className="h-6 w-6 text-blue-400" data-id="element-20359" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-20360">
                <dl data-id="element-20361">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-20362">
                    Pending Onboarding
                  </dt>
                  <dd data-id="element-20363">
                    <div className="text-lg font-medium text-gray-900" data-id="element-20364">
                      {pendingOnboarding}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>

        <button onClick={() => setCurrentView('vendors')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-20365">
          <div className="p-5" data-id="element-20366">
            <div className="flex items-center" data-id="element-20367">
              <div className="flex-shrink-0" data-id="element-20368">
                <AlertTriangleIcon className="h-6 w-6 text-yellow-400" data-id="element-20369" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-20370">
                <dl data-id="element-20371">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-20372">
                    Compliance Issues
                  </dt>
                  <dd data-id="element-20373">
                    <div className="text-lg font-medium text-gray-900" data-id="element-20374">
                      {complianceIssues}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>
      </div>

      {/* Recent Vendors and Compliance Issues */}
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2" data-id="element-20375">
        <div className="bg-white shadow overflow-hidden sm:rounded-md mb-8" data-id="element-20376">
          <div className="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between items-center" data-id="element-20377">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-20378">
              Recently Updated Vendors
            </h3>
            <button onClick={() => setCurrentView('vendors')} className="text-sm text-indigo-600 hover:text-indigo-900" data-id="element-20379">
              View all
            </button>
          </div>
          <ul className="divide-y divide-gray-200" data-id="element-20380">
            {recentVendors.length === 0 ? <li className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-20381">
                No vendors found.
              </li> : recentVendors.map(vendor => <li key={vendor.vendorId} className="px-4 py-4 sm:px-6 hover:bg-gray-50 cursor-pointer" onClick={() => setCurrentView('vendors')} data-id="element-20382">
                  <div className="flex items-center justify-between" data-id="element-20383">
                    <div className="flex items-center" data-id="element-20384">
                      <div className="flex-shrink-0" data-id="element-20385">
                        <UsersIcon className="h-5 w-5 text-gray-400" data-id="element-20386" />
                      </div>
                      <p className="ml-2 text-sm font-medium text-indigo-600 truncate" data-id="element-20387">
                        {vendor.vendorName}
                      </p>
                    </div>
                    <div className="ml-2 flex-shrink-0" data-id="element-20388">
                      {getStatusBadge(vendor.vendorStatus?.name)}
                    </div>
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between" data-id="element-20389">
                    <div className="sm:flex" data-id="element-20390">
                      <p className="flex items-center text-sm text-gray-500" data-id="element-20391">
                        {vendor.type} • {vendor.country}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-20392">
                      <p data-id="element-20393">
                        Last updated:{' '}
                        <span className="ml-1.5" data-id="element-20394">
                          {new Date(vendor.createdUtc).toLocaleDateString(locale)}
                        </span>
                      </p>
                    </div>
                  </div>
                </li>)}
          </ul>
        </div>

        <div className="bg-white shadow overflow-hidden sm:rounded-md mb-8" data-id="element-20395">
          <div className="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between items-center" data-id="element-20396">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-20397">
              Compliance Issues
            </h3>
            <button onClick={() => setCurrentView('vendors')} className="text-sm text-indigo-600 hover:text-indigo-900" data-id="element-20398">
              View all
            </button>
          </div>
          <ul className="divide-y divide-gray-200" data-id="element-20399">
            {vendorsWithIssues.length === 0 ? <li className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-20400">
                No compliance issues found.
              </li> : vendorsWithIssues.map(vendor => <li key={vendor.vendorId} className="px-4 py-4 sm:px-6 hover:bg-gray-50 cursor-pointer" onClick={() => setCurrentView('vendors')} data-id="element-20401">
                  <div className="flex items-center justify-between" data-id="element-20402">
                    <div className="flex items-center" data-id="element-20403">
                      <div className="flex-shrink-0" data-id="element-20404">
                        <AlertTriangleIcon className="h-5 w-5 text-yellow-400" data-id="element-20405" />
                      </div>
                      <p className="ml-2 text-sm font-medium text-indigo-600 truncate" data-id="element-20406">
                        {vendor.vendorName}
                      </p>
                    </div>
                    <div className="ml-2 flex-shrink-0" data-id="element-20407">
                      {vendor.isCompliant ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-20408">
                          <CheckCircleIcon className="mr-1 h-3 w-3" data-id="element-20409" />
                          Compliant
                        </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-20410">
                          <AlertTriangleIcon className="mr-1 h-3 w-3" data-id="element-20411" />
                          Non-Compliant
                        </span>}
                    </div>
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between" data-id="element-20412">
                    <div className="sm:flex" data-id="element-20413">
                      <p className="flex items-center text-sm text-gray-500" data-id="element-20414">
                        {getComplianceIssue(vendor)}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-20415">
                      <p data-id="element-20416">
                        <button className="text-indigo-600 hover:text-indigo-900" onClick={e => {
                    e.stopPropagation();
                    setCurrentView('vendors');
                  }} data-id="element-20417">
                          Review
                        </button>
                      </p>
                    </div>
                  </div>
                </li>)}
          </ul>
        </div>
      </div>
    </div>;
}
// Helper function to render status badges
function getStatusBadge(status) {
  switch (status) {
    case 'Active':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-20418">
          <CheckCircleIcon className="mr-1 h-3 w-3" data-id="element-20419" />
          {status}
        </span>;
    case 'Pending Onboarding':
    case 'Invited':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-20420">
          <ClockIcon className="mr-1 h-3 w-3" data-id="element-20421" />
          {status}
        </span>;
    case 'Inactive':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-20422">
          <UsersIcon className="mr-1 h-3 w-3" data-id="element-20423" />
          {status}
        </span>;
    default:
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-20424">
          {status}
        </span>;
  }
}
function getComplianceIssue(vendor) {
  if (vendor.complianceIssues.length === 0) {
    return 'No specific issues';
  }
  const issue = vendor.complianceIssues[0];
  return issue.notes || issue.complianceIssueType.name;
}